import type { TeamMember, TeamMembersData } from "./selectTeamMembers";

function patchMember(member: TeamMember, userId: string, isFavourite: boolean): TeamMember {
    if (member.user_id !== userId || member.isFavourite === isFavourite) return member;
    return { ...member, isFavourite };
}

export function applyFavouriteToTeamMembers(
    data: TeamMembersData,
    userId: string,
    isFavourite: boolean
): TeamMembersData {
    const all = data.all.map((member) => patchMember(member, userId, isFavourite));
    const members = data.members.map((member) => patchMember(member, userId, isFavourite));
    const invitedByMe = data.invitedByMe.map((member) => patchMember(member, userId, isFavourite));
    const byOrganisation = data.byOrganisation.map((org) => ({
        ...org,
        members: org.members.map((member) => patchMember(member, userId, isFavourite)),
    }));

    const patchedFavourites = data.favourites.map((member) => patchMember(member, userId, isFavourite));
    let favourites: TeamMember[];
    if (isFavourite) {
        const alreadyListed = patchedFavourites.some((member) => member.user_id === userId);
        if (alreadyListed) {
            favourites = patchedFavourites;
        } else {
            const source =
                members.find((member) => member.user_id === userId) ?? all.find((member) => member.user_id === userId);
            favourites = source ? [...patchedFavourites, source] : patchedFavourites;
        }
    } else {
        favourites = patchedFavourites.filter((member) => member.user_id !== userId);
    }

    return {
        ...data,
        all,
        members,
        invitedByMe,
        byOrganisation,
        favourites,
        counts: {
            ...data.counts,
            favourites: favourites.length,
        },
    };
}
